import React from "react";







function InfinityLoader(){


  return (

        <div className="w-full flex justify-center items-center">
            <img src="/loading_trans.gif" className="w-60" />
        </div>
  )



}


export default InfinityLoader
